/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import * as SpriteSpin from 'spritespin';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const prop65Labels = $( 'img[title=CA-P65-Warning-Label]' );
      if ( prop65Labels.length > 0 ) {
        prop65Labels.each( function( index, elem ) {
          $( elem ).parent().remove();
        } );
      }
      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'click', '.js-popup-init-video', function( e ) {
        $.magnificPopup.close();

        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
            type: 'iframe',
          },
        } );

        e.preventDefault();
      } );

      $( '.search-toggle' ).on( 'toggleAfter', function( e ) {
        if ( $( e.target ).hasClass( 'is-active' ) ) {
          $( '.search-area input' ).focus();
        } else {
          $( this ).focus();
        }
      } );

      $( '.product-nav-toggle' ).on( 'toggleAfter', function( e ) {
        $( '.product-nav' ).slideToggle();
      } );

      if ( window.innerWidth < 1024 ) {
        delete document.querySelector( '.navbar-toggle' ).dataset.toggleOutside;
      } else if ( window.innerWidth > 1023 ) {
        document.querySelector( '.navbar-toggle' ).dataset.toggleOutside = true;
        if ( document.querySelector( '.desktop-active__product-item' ) ) {
          document.querySelector( '.desktop-active__product-item' ).click();
        }
      }

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( navigator.appVersion.indexOf( 'Win' ) != -1 ) {
        $( '.form-skin select option' ).css( {'background-color': 'black'} );
      }

      if ( typeof( gform ) !== 'undefined' ) {
        if ( $( '.gform_wrapper' ).length > 0 ) {
          gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
            if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
              const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
              $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
              $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
            } else {
              $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
              $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
            }
          }, 10, 3 );
        }
      }

      $( '.woocommerce-product-gallery__wrapper' ).slick( {
        arrows: false,
        draggable: false,
        swipe: false,
        accessibility: false,
        touchMove: false,
        fade: true,
      } );

      $( '.woocommerce div.product div.images .images-gallery' ).slick( {
        slidesToShow: 3,
        asNavFor: '.woocommerce-product-gallery__wrapper',
        focusOnSelect: true,
        prevArrow: '',
        nextArrow: '<button type="button" class="ll-slick-next"><svg class="icon icon-right-arrow text-2xl"><use xlink:href="#icon-right-arrow"></use></svg></button>',
      } );

      $( '.woocommerce-product-gallery__wrapper' ).magnificPopup( {
        delegate: 'div:not(.slick-cloned) a', // the selector for gallery item
        image: {
          markup: '<div class="mfp-figure">'+
          '<div class="mfp-close"></div>'+
          '<a class="popup-link block" target="_blank" href="#"><div class="mfp-img"></div></a>'+
          '<div class="mfp-bottom-bar">'+
            '<div class="mfp-title"></div>'+
            '<div class="mfp-counter"></div>'+
            '</div>'+
          '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
        },
        type: 'image',
        gallery: {
          enabled: true,
          navigateByImgClick: false,
        },
        callbacks: {
          markupParse: function( template, values, item ) {
            template.find( 'a.popup-link' ).prop( 'href', item.src );
          },
        },
      } );

      if ( $( '.spritespin' ).length > 0 ) {
        const images360 = $( '.spritespin' ).data( 'images' );
        const image360 = images360[images360.length - 1];
        const pathArray = image360.split( '/' );
        const lastImage = pathArray[pathArray.length - 1];
        const range = lastImage.match( /(\d+)-(\d+)(.+)?\.jpg$/ );

        $( '.spritespin' ).spritespin( {
          source: images360,
          width: 1000,
          height: 1000,
          lanes: parseInt( range[1] ),
          frames: parseInt( range[2] ),
          sense: -1,
          senseLane: -1,
          responsive: true,
          lane: 0,
          frame: 0,
          animate: false,
          wrapLane: true,
          plugins: [
            '360',
            'drag',
          ],
        } );
      }

      $( '.child-product a' ).click( function() {
        let wpadminBarHeight = 0;
        if ( $( '#wpadminbar' ).length > 0 ) {
          wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
        }
        const headerHeight = $( 'header.navbar' ).outerHeight();
        const target = $( this.hash );
        if ( target.length ) {
          $( 'html, body' ).animate( {
            scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight ),
          }, 1000 );
          return false;
        }
      } );
    },
    finalize: function() {
      function responsiveEmbed() {
        $( '.wysiwyg iframe' ).wrap( '<div class="embed-container"></div>' );
        $( 'div.embed-container:has(iframe[name*="gform_ajax_frame_"])' ).css( 'display', 'none' );
      }
      responsiveEmbed();
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
